// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of the modal alert to display. Ex: 'Alert' will alert people to an issue. */
export const ModalAlertType = {
    Alert: "Alert",
    Information: "Information",
    Warning: "Warning",
    None: "None"
} as const;

/** The type of the modal alert to display. Ex: 'Alert' will alert people to an issue. */
export type ModalAlertType = typeof ModalAlertType[keyof typeof ModalAlertType];